module.exports = __webpack_public_path__ + "img/renwu1.72cdd3ad.png";